import React, { useRef, useState } from 'react';
import { FileSignature } from 'lucide-react';

export default function SalesEntry({ onStart, hasWhatsApp }) {
    const starting = useRef(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const start = async () => {
        if (starting.current) return;
        starting.current = true; setBusy(true); setError('');
        try {
            const tramite = await onStart();
            if (!tramite?.id) throw new Error('No se ha podido iniciar el alta. Inténtalo de nuevo.');
        } catch {
            setError('No se ha podido iniciar el alta. Inténtalo de nuevo.');
        } finally {
            starting.current = false; setBusy(false);
        }
    };
    return <section className="max-w-3xl mx-auto p-8 rounded-2xl border border-slate-700 bg-slate-900/50">
        <FileSignature size={28} className="text-primary mb-4" />
        <h2 className="text-xl font-bold text-slate-100">Alta de contrato</h2>
        <p className="text-slate-400 mt-3 mb-5">Inicia un alta para completar los datos del titular, el suministro y la tarifa en el formulario de contratación.</p>
        <button type="button" disabled={busy} onClick={start}
            className="px-4 py-3 rounded-xl border border-primary/30 bg-primary/10 text-primary hover:bg-primary/20 disabled:opacity-50 font-medium">
            {busy ? 'Iniciando alta…' : 'Iniciar alta'}
        </button>
        {error && <p role="alert" className="mt-4 text-rose-400">{error}</p>}
        {hasWhatsApp && <p className="text-sm text-slate-400 mt-5">Para continuar una gestión de WhatsApp, abre su conversación desde la bandeja.</p>}
    </section>;
}
